import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import MATERIAL_DATA from "./materialData";
import { asset } from "../../../helpers/dom.helper";
import { Media, MediaContextProvider } from "../../../media";
import WhyLussopackMoreInfo from "../../../components/whyLussopack/whyLussoPackMoreInfo";
import './materialContainer.scss'

const MaterialContainer = (props) => {
    const {materialName} = useParams()
    const materialPageData = MATERIAL_DATA.find((mat)=>(mat.matName === materialName))

    const summaryDescription = (isMobile) => (
        <div className={isMobile ? 'summaryDescriptionMobile' : 'summaryDescription'}>
          <h2 className='mb-3 mt-5'>Lussopack: Your Custom Luxury Packaging Partner</h2>
          <p>Based in Bangkok, Thailand, Lussopack is a leading luxury packaging manufacturer with over 30 years of expertise, delivering exceptional quality and personalized service.</p>
          <h3 className="mb-2">More Than Manufacturing</h3>
          <p>We work with global luxury brands to craft luxury packaging that fosters emotional connections, builds brand loyalty, and inspires advocacy.</p>
          <h3 className="mb-2">Broad Specialization </h3>
          <p>From jewelry packaging to custom designs for high-end brands like perfume, rigid, and gift boxes, we ensure superior Thailand craftsmanship in every product.</p>
    
          <h3 className="mb-2">Tailor-Made Solutions</h3>
          <p>Choose from an extensive range of premium materials and finishes, or work with our experts to develop bespoke packaging that embodies your brand's essence.</p>
          <h3 className="mb-2">Efficient Logistics Services</h3>
          <p>Take advantage of our warehousing, distribution, and direct packaging solutions to streamline operations, cut costs, and manage your supply chain with ease.</p>
          <h3 className="mb-2">Client-Focused Commitment</h3>
          <p>At Lussopack, we are passionate about delivering flawless packaging solutions that align with your brand’s vision and exceed your expectations.</p>
          <h3 className="mb-2">Contact Us Today</h3>
          <p>Let us help bring your luxury packaging vision to life. Reach out to our team and discover how we can create the perfect solution for your bran</p>
      </div>      
      )

    return (
        <>
            <Helmet>
                <title>{materialPageData.titleTag}</title>
                <meta name="description" content={materialPageData.metaDescription} />
                <meta name="keywords" content={materialPageData.matName} />
                <link rel="canonical" href="https://lussopack.com/our-materials/" />  
            </Helmet>
            <HeaderTitle
                {...props}
                textHeader={materialPageData.headerTitle.main}
                textSubHeader={materialPageData.headerTitle.sub}
                desktopImageUrl={"/images/ourMaterial/desktop/Lussopack-Our-Materials-Cover.webp"}
                mobileImageUrl={"/images/ourMaterial/mobile/Lussopack-Our-Materials-Cover.webp"}
                isShowOurReference={true}
            />
            <MediaContextProvider>
                <Media greaterThanOrEqual="md">
                    <div id="materialContainer">
                        {materialPageData.materialInfo.map((matInfo, index) => {
                            if(matInfo.img) {
                                return <div className="d-flex justify-content-center mb-3 mt-3">
                                        <img
                                            className="mb-4" 
                                            src={asset(matInfo.img)}                 
                                            width="45%" 
                                            alt="contentDescription"
                                        />
                                </div>
                            } else {
                                return <div className="matInfo" key={index} dangerouslySetInnerHTML={{ __html: matInfo }} />
                            }                 
                        })}
                        <div className="mt-5">
                            <WhyLussopackMoreInfo />
                            {summaryDescription}
                        </div>
                    </div>
                </Media>
                <Media lessThan="md">
                    <div id="materialContainer">
                        {materialPageData.materialInfo.map((matInfo, index) => {
                            if(matInfo.img) {
                                return <div className="d-flex justify-content-center mb-3 mt-3">
                                        <img src={asset(matInfo.img)}                 
                                            width="70%" 
                                            alt="contentDescription"
                                        />
                                </div>
                            } else {
                                return <div className="matInfoMobile" key={index} dangerouslySetInnerHTML={{ __html: matInfo }} />
                            }                 
                        })}
                        <div className="mt-5 mobile" >
                            <WhyLussopackMoreInfo />
                            {summaryDescription(true)}
                        </div>
                    </div>
                </Media>
            </MediaContextProvider>
        </>
    )
}

export default MaterialContainer